import { Routes } from '@angular/router';
import { ngxPermissionsGuard } from 'ngx-permissions';
import { authGuard, notAuthedGuard } from 'src/app/core/guard/auth.guard';
import { OrGuard } from 'src/app/core/guard/utils.guard';

export default [
  {
    path: '',
    canActivateChild: [ngxPermissionsGuard, authGuard],
    canMatch: [OrGuard.bind(null, [notAuthedGuard, ngxPermissionsGuard])],
    loadComponent: () => import('../../shared/components/layout/content/content.component').then(m => m.ContentComponent),
    loadChildren: () => import('../../modules/eaglebe-superuser/superuser.routes'),
    data: {
      permissions: {
        only: 'viewSuperUser'
      }
    }
  },
  {
    path: '',
    canActivateChild: [ngxPermissionsGuard, authGuard],
    canMatch: [OrGuard.bind(null, [notAuthedGuard, ngxPermissionsGuard])],
    loadComponent: () => import('../../shared/components/layout/content/content.component').then(m => m.ContentComponent),
    loadChildren: () => import('../../modules/eaglebe-backoffice/backoffice.routes'),
    data: {
      permissions: {
        only: 'viewUser',
        except: 'viewSuperUser'
      }
    }
  }/* ,
  {
    path: '',
    loadChildren: () => import('../../modules/eaglebe-frontoffice/frontoffice.routes')
  } */
] satisfies Routes;